// extracted by mini-css-extract-plugin
export default {"main":"style_main__HhLXj","content":"style_content__+qTPj","constructor":"style_constructor__-REFN"};